import cmp from './RequestVerification'

export default cmp
